import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NewsArticle, RelatedNewsArticle } from 'app/profile/news/news-profile.model';
import { NewsService } from 'app/profile/news/news-profile.service';
import { WriteArticleFormComponent } from 'app/shared/components/forms/write-article-form/write-article-form.component';
import { NewsViewHeaderComponent } from 'app/shared/components/news-view-header/news-view-header.component';
import { RelatedNewsComponent } from 'app/shared/components/related-news/related-news.component';
import { Mode } from 'app/shared/enums/news-admin.enum';
import { BackNavigationComponent } from "../shared/components/back-navigation/back-navigation.component";

@Component({
  selector: 'app-news-details',
  standalone: true,
  imports: [CommonModule, NewsViewHeaderComponent, TranslateModule, RelatedNewsComponent, WriteArticleFormComponent, BackNavigationComponent],
  templateUrl: './news-details.component.html',
  styleUrl: './news-details.component.scss'
})
export class NewsDetailsComponent {
  selectedNews: NewsArticle | null = null;
  relatedNews: RelatedNewsArticle[] = [];
  form!: FormGroup; 
  currentMode = Mode.View;
  Mode = Mode;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private newsService: NewsService,
    private fb: FormBuilder 
  ) {}

  ngOnInit(): void {
    this.initializeForm(); 
    this.route.params.subscribe(params => {
      const newsId = params['id'];
      if (newsId) {
        this.loadNewsDetails(+newsId);
      }
    });
  }

  initializeForm(): void {
    this.form = this.fb.group({
      articleTitle: [{ value: '', disabled: true }],
      articleContent: [{ value: '', disabled: true }]
    });
  }

  loadNewsDetails(id: number): void {
    this.newsService.getNews(id).subscribe(newsItem => {
      this.selectedNews = newsItem;
      this.relatedNews = newsItem.relatedNewsArticles || [];

      this.form.patchValue({
        articleTitle: newsItem.title,
        articleContent: newsItem.body || newsItem.shortBody || ''
      });
    });
  }

  onGoBack(): void {
    this.router.navigate(['/news-announcements']);
  }
}
